import { render, staticRenderFns } from "./Template17.vue?vue&type=template&id=a00fc2da&scoped=true&"
import script from "./Template17.vue?vue&type=script&lang=js&"
export * from "./Template17.vue?vue&type=script&lang=js&"
import style0 from "./Template17.vue?vue&type=style&index=0&id=a00fc2da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00fc2da",
  null
  
)

export default component.exports